// @flow strict

import useI18n from 'src/hooks/useI18n';
import type {
  TranslationFunction,
  MakeKeyFunction,
} from 'src/types/language-support';


export default function useLabelTranslation(): {
  t: TranslationFunction,
  makeKey: MakeKeyFunction,
  language: string,
} {
  const {labelI18nInstance} = useI18n();
  const makeKey = (value: string) => {
    try {
      if (value && typeof value === 'string') {
        return value
          .replace(/\(s\)/gi, '_s') // Replace (s) with _s (case-insensitive)
          .replace(/[^\w\s']/g, '') // Remove special chars except apostrophes
          .replace(/\s+/g, '_') // Spaces → underscores
          .replace(/_+/g, '_') // Collapse multiple ____ into _
          .replace(/^_|_$/g, ''); // Trim leading/trailing _
      }
      return value;
    } catch {
      return value;
    }
  };
  return {
    t: labelI18nInstance.t,
    makeKey,
    language: labelI18nInstance.language,
  };
}
